__turbopack_context__.v({
  "className": "caveat_9ebfe5c2-module__jyNVyG__className",
  "variable": "caveat_9ebfe5c2-module__jyNVyG__variable",
});
